module.exports = __webpack_public_path__ + "static/media/collaborate-icon.92f7fe8b.png";